export const occupations = [
  { text: '', value: ''},
  { text: 'Teacher', value: 'teacher'},
  { text: 'Student', value: 'student'},
  { text: 'Entrepeneur', value: 'entrepeneur'},
  { text: 'Other', value: 'other'},
];



// WEBPACK FOOTER //
// ./src/common/utils/data/occupations.js